import React from 'react';
export function ContentSections() {
  return <section className="w-full py-12 bg-[#F5F7FA]" data-id="element-92">
      <div className="max-w-3xl mx-auto px-4 text-lg md:text-xl text-gray-800 leading-relaxed space-y-6" data-id="element-93">
        <p className="font-bold text-center text-2xl mb-8" data-id="element-94">
          Si tienes un niño pequeño en casa, déjame hacerte una pregunta honesta
        </p>

        <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 text-center mb-8 shadow-sm" data-id="element-95">
          <p className="font-bold text-red-600 text-xl md:text-2xl" data-id="element-96">
            ¿Te pasa que muchas veces no sabes cómo mantenerlo entretenido sin
            darle el celular o la tablet?
          </p>
        </div>

        <p data-id="element-97">No porque seas mal padre o madre.</p>
        <p data-id="element-98">No porque no te importe su desarrollo.</p>
        <p className="font-bold" data-id="element-99">
          Sino porque no siempre es fácil encontrar actividades educativas que
          realmente les gusten.
        </p>

        <p className="pt-6" data-id="element-100">A muchos padres les pasa lo mismo.</p>
        <p data-id="element-101">
          Quieren estimular el aprendizaje de sus hijos, pero se encuentran con
          problemas como:
        </p>

        <ul className="space-y-3 pl-4 md:pl-8 py-4" data-id="element-102">
          <li className="flex items-start gap-3" data-id="element-103">
            <span className="text-red-500 font-bold mt-1" data-id="element-104">•</span>
            <span data-id="element-105">El niño se aburre rápido</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-106">
            <span className="text-red-500 font-bold mt-1" data-id="element-107">•</span>
            <span data-id="element-108">Es difícil mantener su atención</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-109">
            <span className="text-red-500 font-bold mt-1" data-id="element-110">•</span>
            <span data-id="element-111">Terminan pasando mucho tiempo frente a pantallas</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-112">
            <span className="text-red-500 font-bold mt-1" data-id="element-113">•</span>
            <span data-id="element-114">No siempre saben qué actividades hacer en casa</span>
          </li>
        </ul>

        <p className="pt-4" data-id="element-115">Y al final del día queda esa sensación de:</p>
        <blockquote className="italic font-bold text-gray-600 border-l-4 border-blue-500 pl-4 py-2 my-6 bg-blue-50 rounded-r-lg" data-id="element-116">
          "Me gustaría hacer más actividades educativas con mi hijo…"
        </blockquote>

        <h3 className="text-2xl md:text-3xl font-black text-center pt-8 pb-4" data-id="element-117">
          Aprender en casa no debería ser complicado
        </h3>

        <p data-id="element-118">El problema que casi nadie dice en voz alta es este:</p>

        <div className="bg-yellow-100 p-6 rounded-xl border-l-4 border-yellow-500 my-6" data-id="element-119">
          <p className="font-bold" data-id="element-120">
            👉 Muchos niños pasan demasiado tiempo frente a pantallas
            simplemente porque faltan ideas de actividades educativas.
          </p>
        </div>

        <p data-id="element-121">
          Pero la realidad es que los niños aprenden mejor cuando juegan,
          exploran y crean.
        </p>
        <p data-id="element-122">Cuando pueden:</p>

        <ul className="space-y-2 pl-4 md:pl-8 py-4 font-medium" data-id="element-123">
          <li className="flex items-center gap-2" data-id="element-124">
            <span className="text-blue-500" data-id="element-125">•</span> pintar
          </li>
          <li className="flex items-center gap-2" data-id="element-126">
            <span className="text-blue-500" data-id="element-127">•</span> resolver pequeños desafíos
          </li>
          <li className="flex items-center gap-2" data-id="element-128">
            <span className="text-blue-500" data-id="element-129">•</span> manipular objetos
          </li>
          <li className="flex items-center gap-2" data-id="element-130">
            <span className="text-blue-500" data-id="element-131">•</span> descubrir cosas nuevas
          </li>
        </ul>

        <p className="font-bold text-xl text-center py-4 text-blue-600" data-id="element-132">
          Ahí es donde realmente se desarrolla su mente.
        </p>

        <p className="text-center pb-8" data-id="element-133">
          Lo difícil es tener actividades educativas organizadas y listas para
          usar.
        </p>

        {/* The Solution Intro */}
        <div className="bg-blue-600 text-white p-8 rounded-2xl shadow-xl text-center mt-8" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-135">
            ✅ LA SOLUCIÓN
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-yellow-300 mb-6" data-id="element-136">
            Mega Pack Actividades para Niños
          </h3>
          <p className="text-lg md:text-xl mb-8" data-id="element-137">
            Un sistema educativo completo con más de 500 actividades diseñadas
            para estimular el desarrollo infantil a través del juego.
          </p>
          <p className="text-lg mb-8 font-medium" data-id="element-138">
            Todo organizado para que puedas usarlo fácilmente en casa.
          </p>

          <div className="flex flex-col gap-4 text-left max-w-sm mx-auto bg-white/10 p-6 rounded-xl" data-id="element-139">
            <p className="flex items-center gap-3" data-id="element-140">
              <span className="text-2xl" data-id="element-141">📂</span> Descargas el material
            </p>
            <p className="flex items-center gap-3" data-id="element-142">
              <span className="text-2xl" data-id="element-143">🖨</span> Imprimes las actividades
            </p>
            <p className="flex items-center gap-3" data-id="element-144">
              <span className="text-2xl" data-id="element-145">🎨</span> Tu hijo aprende mientras
              juega
            </p>
          </div>

          <div className="mt-8 font-bold text-xl space-y-2" data-id="element-146">
            <p data-id="element-147">Sin improvisar.</p>
            <p data-id="element-148">Sin depender de pantallas.</p>
          </div>
        </div>
      </div>
    </section>;
}